import Vue from 'vue'
import Router from 'vue-router'

//页面
import Index from '@/pages/index/index'
import Product from '@/pages/products/index'
import ProductsList from '@/pages/products/list'
import ProductInfo from '@/pages/products/info'
import About from '@/pages/about/index'
import News from '@/pages/news/index'
import NewsInfo from '@/pages/news/info'
import Support from '@/pages/support/index'
import SupportInfo from '@/pages/support/info'
import Search from '@/pages/search/index'
import Job from '@/pages/job/index'
import SocialList from '@/pages/job/social-list'
import SocialInfo from '@/pages/job/social-info'

Vue.use(Router);

export default new Router({
	mode: 'history',
	scrollBehavior(to, from, savePosition) {
		if(savePosition){
			return savePosition
		}else{
			return { x: 0, y: 0 }
		}
	},
	routes: [
		{
		  path: '*',
		  redirect: '/'
		},{
			path: '/',
			name: 'Index',  //主页
			component: Index,
			meta: {
				requireAuth: true
			}
		},{
			path: '/product.html',
			name: 'Product',  //产品主页
			component: Product,
			meta: {
				requireAuth: true
			}
		},{
			path: '/product-list.html',
			name: 'ProductsList',  //产品列表
			component: ProductsList,
			meta: {
				requireAuth: true
			}
		},{
			path: '/product-info/:productInfoId',
			name: 'ProductInfo',  //产品详情
			component: ProductInfo,
			meta: {
				requireAuth: true
			}
		},{
			path: '/about/:aboutId',
			name: 'About',  //关于我们
			component: resolve => require(['@/pages/about/index'], resolve), 
			meta: {
				requireAuth: true
			}
		},{
			path: '/news/:newsId',
			name: 'News',  //新闻资讯
			component: resolve => require(['@/pages/news/index'], resolve), 
			meta: {
				requireAuth: true
			}
		},{
			path: '/news-info/:newInfoId',
			name: 'NewsInfo',  //新闻资讯详情
			component: NewsInfo,
			meta: {
				requireAuth: true
			}
		},{
			path: '/support/:supportId',
			name: 'Support',  //技术支持
			component: resolve => require(['@/pages/support/index'], resolve),
			meta: {
				requireAuth: true
			}
		},{
			path: '/support-info/:supportInfoId',
			name: 'SupportInfo',  //技术支持详情
			component: SupportInfo,
			meta: {
				requireAuth: true
			}
		},{
			path: '/search.html',
			name: 'Search',  //搜索页面
			component: Search,
			meta: {
				requireAuth: true
			}
		},{
			path: '/job.html',
			name: 'Job',  //招聘页面
			component: resolve => require(['@/pages/job/index'], resolve),
			meta: {
				requireAuth: true
			}
		},{
			path: '/job/:jobId',
			name: 'JobList',  //招聘列表
			component: resolve => require(['@/pages/job/social-list'], resolve),
			meta: {
				requireAuth: true
			}
		},{
			path: '/job-info/:type/:jobInfoId',
			name: 'JobInfo',  //招聘详情
			component: resolve => require(['@/pages/job/social-info'], resolve),
			meta: {
				requireAuth: true
			}
		}
	]
})